import { memoize } from 'lodash'

// returns a data URL that can be used as a background image in css
function pixelDataURL(hex = '#FFFFFF') {
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = 1
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = hex
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  return canvas.toDataURL()
}

export const getPixelDataURL = memoize(pixelDataURL)
